<template>
    <div :class="(setClass ? setClass : '') + ' layering_section '">
        <div class="layer_parent_div layer_main_custom_box">
            <button @click="setValue('back')" class="bcommon b1 active first">
                <img
                    src="./icon/layer1.png"
                    style="transform: rotate(180deg)"
                />
            </button>
            <button @click="setValue('front')" class="bcommon b2 last">
                <img src="./icon/layer2.png" />
            </button>
        </div>
        <label>Layering</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Layering",
    /* eslint-enable */
    props: ["value", "setClass"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", e);
        },
        setActive(e) {
            return e == this.value ? "active" : "";
        }
    }
};
</script>

<style>
.layer_parent_div {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin: 0px 15px;
}

.bcommon {
    background-color: initial;
    color: #7796a8;
    border: 1px solid;
    border-radius: 0 !important;
    background: #7796a8;
    width: 40px;
}

.b1 {
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
}

.b2 {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
</style>
